export default __webpack_public_path__ + "680aff80ab7a68f0418dd4d9b1600d53.png";